export default {
    book: 'Reservar {product}',
    age_limit: 'Solo para mayores de {age} años',
    change_plan: 'Cambiar Plan',
    upgrade_product: 'Mejorar producto',
    upgrade: 'Mejorar',
    cancel_upgrade: 'Cancelar Mejora',
    choose_product: 'Elegir {product}',
    days: '{count} día | {count} días',
    login_register: 'Iniciar sesión/Registrarse',
    current: 'Actual',
    keyless_benefits: {
        label: 'Directo al coche {0}',
        highlight: 'servicio de alquiler™',
        list: {
            cant_lose_the_key: 'Seguro Completo',
            zero_excess: 'Sin Franquicia',
            phone_as_a_key: 'Teléfono como Llave',
            straight_to_car: 'Sin esperas',
            no_queues: 'Sin colas',
            online_id_check: 'Verificación de ID en línea',
            self_checkout: 'Auto Check-out',
        },
    },
};
